import React from 'react';
import PropTypes from 'prop-types';
import { UploadOutlined } from '@ant-design/icons';
// import ReactHtmlParser from 'react-html-parser';

// import { Row, Col } from 'reactstrap';

// // Local Depsimport { Upload, Button, Icon } from 'antd';

import { Card, Button, Upload, Select, Input } from 'antd';
import ComposeMessage from '../../components/ComposeMessage';
// import FileDetector from '../../components/fileDetector';
import './ComposeMessages.scss';

export default class SuperAdminHome extends React.Component {
  static propTypes = {
    saveDraft: PropTypes.func.isRequired,
    activeDraft: PropTypes.string.isRequired,
    onChangeDraft: PropTypes.func.isRequired,
    deleteDraft: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    handleUpload: PropTypes.func.isRequired,
    handleUploadChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    organizationList: PropTypes.any.isRequired,
    setCurrentRecipients: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    currentRecipients: PropTypes.any,
    fileList: PropTypes.any,
    submitting: PropTypes.bool,
  };

  static defaultProps = {
    currentRecipients: [],
    fileList: [],
    submitting: true,
  };

  componentDidMount() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: 'smooth' });
  };

  render() {
    const {
      saveDraft,
      activeDraft,
      onChangeDraft,
      deleteDraft,
      auth,
      handleUpload,
      handleUploadChange,
      fileList,
      onRemove,
      onSubmit,
      organizationList,
      setCurrentRecipients,
      setTitle,
      title,
      currentRecipients,
      submitting,
    } = this.props;

    const uploadProps = {
      progress: {
        // strokeColor: {
        //   '0%': '#108ee9',
        //   '100%': '#87d068',
        // },
        strokeWidth: 5,
        format: (percent) => percent && `${parseFloat(percent)}%`,
      },
    };


    return (
      <div className="compose-messages">
        <div className="compose-message-wrapper">
          <div className="card-wrapper">
            <Card>
              <span className="card-selection-wrapper">
                <div className="card-selection-to">
                  <p>To</p>
                </div>
                <Select
                  showSearch
                  className="card-selection"
                  placeholder="Select an Organization"
                  optionFilterProp="children"
                  onChange={cage => {
                    setCurrentRecipients(cage);
                  }}
                  value={currentRecipients}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {organizationList}
                </Select>
              </span>
              <Input
                value={title}
                onChange={setTitle}
                placeholder="Add a subject"
                className="subject"
              />
              <ComposeMessage
                auth={auth}
                saveDraft={saveDraft}
                activeDraft={activeDraft}
                onChangeDraft={onChangeDraft}
                customStyling
              />
              <div className="message-actions">
                <Button
                  disabled={submitting}
                  type="primary"
                  onClick={async () => {
                    await onSubmit();
                  }}
                >
                  Send
                </Button>
                <Button onClick={() => deleteDraft()}>Discard</Button>
                <Upload {...uploadProps}
                  fileList={fileList}
                  customRequest={handleUpload}
                  onChange={handleUploadChange}
                  onRemove={onRemove}

                >
                  <Button
                    style={{
                      backgroundColor: '#ff7c52',
                      color: 'white',
                      border: 'none',
                    }}
                  >
                    Upload Attachments <UploadOutlined />
                  </Button>
                </Upload>
              </div>
            </Card>
          </div>
          <div
            style={{ float: 'left', clear: 'both' }}
            ref={el => {
              this.messagesEnd = el;
            }}
          />
        </div >
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ComposeMessage/ComposeMessages.jsx